import { Box, Grid } from '@material-ui/core';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { v4 as uuid } from 'uuid';
import { selectEtapas } from '../../features/etapa/etapaSlice';
import QCXFinalBondManager from '../../shared-components/final-gerenciador-relacionamento/QCXFinalBondManager';
import QCXSelectEtapaAutocomplete from '../../shared-components/select-etapa/QCXSelectEtapaAutocomplete';
import { isStrictEquals } from '../../utils/general/general-utils';

export default function QCXEtapaBondManager({
  isConsult = false,
  listRootName = 'listaEtapasEnvioEmail',
  filterPredicate = undefined,
}) {
  const { t } = useTranslation();

  const unfilteredEtapas = useSelector(selectEtapas);

  const etapas = useMemo(
    () => (filterPredicate ? unfilteredEtapas.filter(filterPredicate) : unfilteredEtapas),
    [unfilteredEtapas]
  );

  const handleAdd = useCallback((currentVinculo, currentVinculos, handleSuccessAddVinculo) => {
    const novoVinculo = {
      id: uuid(),
      etapa: currentVinculo.etapa,
    };

    const updatedVinculos = [...currentVinculos, novoVinculo];

    handleSuccessAddVinculo(updatedVinculos);
  }, []);

  const handleUpdate = useCallback((currentVinculo, currentVinculos, handleSuccessUpdateVinculo) => {
    const updatedVinculos =
      currentVinculos?.map((existingVinculo) =>
        isStrictEquals(existingVinculo?.etapa?.id, currentVinculo?.etapa?.id) ? currentVinculo : existingVinculo
      ) || currentVinculos;

    handleSuccessUpdateVinculo(updatedVinculos);
  }, []);

  const handleAlreadyExists = useCallback(
    (currentVinculo, currentVinculosList) =>
      currentVinculosList.some((vinculo) => isStrictEquals(vinculo?.etapa?.id, currentVinculo?.etapa?.id)),
    []
  );

  const mapEtapaById = (id) => etapas.find((etapa) => etapa.id === id);

  const listProps = {
    name: listRootName,
    columns: [
      {
        field: 'sigla',
        headerName: 'Sigla',
        flex: 200,
        valueGetter: ({ row }) => row?.etapa?.sigla ?? '-',
      },
      {
        field: 'nome',
        headerName: 'Nome',
        flex: 200,
        valueGetter: ({ row }) => mapEtapaById(row?.etapa?.id)?.description ?? '-',
      },
    ],
  };

  const formProps = useMemo(
    () => ({
      rootName: 'ignorableFields.etapaBond',
      fields: [
        {
          name: 'etapa',
          label: 'Etapa',
        },
      ],
    }),
    []
  );

  return (
    <Box style={{ pointerEvents: isConsult ? 'none' : '' }}>
      <QCXFinalBondManager
        isParentConsult={isConsult}
        listProps={listProps}
        formProps={formProps}
        controlButtonsGridProps={{
          add: {
            xs: 12,
            sm: 2,
            md: 2,
          },
          update: {
            xs: 6,
            sm: 6,
            md: 1,
          },
          clear: {
            xs: 6,
            sm: 6,
            md: 1,
          },
        }}
        handleAdd={handleAdd}
        handleUpdate={handleUpdate}
        handleAlreadyExists={handleAlreadyExists}
      >
        <>
          <Grid item sm={6}>
            <QCXSelectEtapaAutocomplete
              etapas={etapas}
              id="autocomplete-select-etapa-field"
              key="autocomplete-select-etapa-field"
              name="ignorableFields.etapaBond.etapa"
              label="Etapa"
              disabled={isConsult}
            />
          </Grid>
        </>
      </QCXFinalBondManager>
    </Box>
  );
}
